import getPageTitle from '@alltrails/shared/utils/getPageTitle';
import PageTitle from '@alltrails/shared/types/PageTitle';
import Link from '@alltrails/shared/denali/components/Link';
import ArrowSq from '@alltrails/shared/icons/ArrowSq';
import useExperiments from 'hooks/useExperiments';

type Props = {
  className?: string;
  title?: string;
};

const GoBack = ({ className, title }: Props) => {
  const experiments = useExperiments();
  const hasByotExperiment = experiments['web-discover-byot-phase2-rm']?.value === 'treatment';
  const pageTitle = getPageTitle(window.location.pathname);
  const EXPLORE_TRAIL_PAGES = [PageTitle.ExploreMapDetails, PageTitle.ExploreRecordingDetails, PageTitle.TrailDetails];

  const isExploreTrailPage = () => EXPLORE_TRAIL_PAGES.includes(pageTitle as PageTitle);

  const navigateBack = () => {
    if (hasByotExperiment && pageTitle === PageTitle.ExploreMapDetails) {
      window.history.back();
      return;
    }
    if (isExploreTrailPage()) {
      const previousPath = window.location.pathname.split('/').slice(0, -1).join('/');
      window.location.replace(previousPath);
    }
    window.history.back();
  };

  return (
    <div className={`backContainer ${className}`}>
      <Link onClick={navigateBack} size="sm" icon={{ Component: ArrowSq, orientation: 'left', title }} />
    </div>
  );
};

GoBack.defaultProps = {
  className: '',
  title: ''
};

export default GoBack;
